import { render, staticRenderFns } from "./post-form.vue?vue&type=template&id=e2d5968c&lang=pug&"
import script from "./post-form.vue?vue&type=script&lang=js&"
export * from "./post-form.vue?vue&type=script&lang=js&"
import style0 from "./post-form.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports